"use strict";

var conditionDirectiveController = [
  "$scope", 'BuilderDataService', '$translate', 'toast',
  function ($scope, BuilderDataService, $translate, toast) {
    var _this = this;
    if (_this.form == undefined && _this.integration == undefined && !_this.actionFields) {
      _this.form = BuilderDataService.getForm();
    }

    this.OperationLabels = {
      "=": $translate.instant('DASHBOARD.DASH_BUILDER.CONDITIONS_GRAPH.OPERATORS.EQUAL'),
      "!=": $translate.instant('DASHBOARD.DASH_BUILDER.CONDITIONS_GRAPH.OPERATORS.DISTINT'),
      "<": $translate.instant('DASHBOARD.DASH_BUILDER.CONDITIONS_GRAPH.OPERATORS.LESS'),
      ">": $translate.instant('DASHBOARD.DASH_BUILDER.CONDITIONS_GRAPH.OPERATORS.GREATER'),
      "<=": $translate.instant('DASHBOARD.DASH_BUILDER.CONDITIONS_GRAPH.OPERATORS.LESS_EQUAL'),
      ">=": $translate.instant('DASHBOARD.DASH_BUILDER.CONDITIONS_GRAPH.OPERATORS.GREATER_EQUAL'),
      "existe": $translate.instant('DASHBOARD.DASH_BUILDER.CONDITIONS_GRAPH.OPERATORS.EXISTS'),
      "!existe": $translate.instant('DASHBOARD.DASH_BUILDER.CONDITIONS_GRAPH.OPERATORS.NOT_EXISTS'),
      "startsWith": $translate.instant('DASHBOARD.DASH_BUILDER.CONDITIONS_GRAPH.OPERATORS.STARTS_WITH'),
      "like": $translate.instant('DASHBOARD.DASH_BUILDER.CONDITIONS_GRAPH.OPERATORS.CONTAINS'),
      "inq": $translate.instant('DASHBOARD.DASH_BUILDER.CONDITIONS_GRAPH.OPERATORS.IN'),
      "nin": $translate.instant('DASHBOARD.DASH_BUILDER.CONDITIONS_GRAPH.OPERATORS.NOT_IN'),
      "between": $translate.instant('DASHBOARD.DASH_BUILDER.CONDITIONS_GRAPH.OPERATORS.BETWEEN'),
      "regexp": $translate.instant('DASHBOARD.DASH_BUILDER.CONDITIONS_GRAPH.OPERATORS.REGEXP'),
    }

    this.getElement = function (fieldId) {
      var element = angular.copy(_this.lstElements.find(function (el) {
        return el.id == fieldId;
      }));
      return element;
    }

    this.validOperations = function (fieldId) {
      var element = _this.getElement(fieldId); /* angular.copy(_this.lstElements.find(function(el){
        return el.id == fieldId;
      })); */

      if (!element) {
        return [];
      }

      if (_this.integration) {
        return ["="];
      }

      if (_this.actionFields) {
        if (element.id === "createdAt" || element.id === "_createdAt" || element.type === "timestamp" || element.type === "date") {
          return ["=", "<", ">", "<=", ">=", "between"];
        }
        return ["=", "!=", "<", ">", "<=", ">=", "startsWith", "like", "inq", "nin", "between", "regexp"];
      }

      if (element.type === "fetchData") {
        element.type = element.fetchDataConfiguration.fieldData.type;
      }

      if ((element.type == 'text' && element.id == 'validateState')) {
        return ["=", "!="];
      } else {
          switch (element.type) {
            case "text":
            case "textarea":
            case "select":
            case "checkbox":
            case "multiple":
                return ["=", "!=", "existe", "!existe", "startsWith"];
            case "autonumeric":
            case "formula":
            case "date":
            case "timestamp":
            case "number":
            case "qr":
              return ["=", "!=", "<", ">", "<=", ">=", "existe", "!existe"];
            default:
              return [];
          }
      }     
    };

    this.removeCondition = function (index) {
      if (_this.use === "dynamic-select") {
        this.element.templateData.dynamicOptions.splice(index, 1);
      } else if (_this.use === "dynamic-mail") {
        this.element.reportDinamicEmail.splice(index, 1)
      } else if (_this.use === "datasource") {
        this.element.filters.splice(index, 1)
      } else {
        this.element.dynamicRequires.splice(index, 1);
      }
    };

    this.removeBlock = function (scope) {
      scope.remove();
      _this.valid = _this.validateConditions(_this.condition.conditions);
    };

    this.addBlock = function (operator, list) {
      if (_this.integration && (operator === "or" || operator === "and")) {
        return;
      }
      switch (operator) {
        case "or":
          list.push({
            type: "operator",
            operator: "or",
            rules: []
          });
          break;
        case "and":
          list.push({
            type: "operator",
            operator: "and",
            rules: []
          });
          break;
        case "field":
          list.push({
            type: "field",
            valueType: 'static',
            fieldId: undefined,
            value: undefined,
            operator: undefined //>,< ,>= >=, !=
          });
          break;
        default:
          break;
      }
      _this.valid = _this.validateConditions(_this.condition.conditions);
    };

    this.getListFieldLabel = (field, withIndent) => {
      if (!field) return "";
      if (_this.use !== "datasource") {
        return field.name || field.label || "";
      }
      if (withIndent === undefined) withIndent = true;
      var level = withIndent ? Math.max(0, field.level || 0) : 0;
      var indent = level ? "\u00A0\u00A0\u00A0\u00A0".repeat(level) : "";
      var label = indent + (field.name || field.label || "");
      if (field.type) {
        label += " (" + field.type + " - " + field.id + ")";
      }
      return label;
    };

    this.getSelectedFieldLabel = (fieldId) => {
      if (!fieldId) return "";
      var element = _this.getElement(fieldId);
      return _this.getListFieldLabel(element, false);
    };

    this.getListFieldGroup = (field) => {
      if (_this.use !== "datasource" || !field || !field.form) return undefined;
      return field.form + " - " + (field.page || "");
    };

    // Aplana group/simplelist con level/form/page (mismo criterio que fórmulas/integraciones).
    // group/simplelist se incluyen como ítems deshabilitados para dar contexto visual.
    this.flattenPageFields = (nodes, level, formType, pageLabel, options) => {
      options = options || {};
      const idPrefix = options.idPrefix || "";
      const isValidate = !!options.isValidate;
      let parentId = options.parentId;
      let result = [];

      (nodes || []).forEach((node) => {
        if (!node) return;
        const childNodes = Array.isArray(node.nodes)
          ? node.nodes
          : (node.nodes ? Object.values(node.nodes) : null);
        const nodeId = idPrefix ? idPrefix.concat(node.id) : node.id;

        if (node.type === "group") {
          result.push({
            id: nodeId,
            name: node.name || node.label || node.type,
            type: node.type,
            templateData: node.templateData,
            label: node.label,
            level: level,
            form: formType,
            page: pageLabel,
            parentId: parentId,
            disabled: true
          });
          if (childNodes && childNodes.length) {
            result = result.concat(
              _this.flattenPageFields(childNodes, level + 1, formType, pageLabel, {
                idPrefix,
                isValidate,
                parentId
              })
            );
          }
        } else if (node.type === "simplelist") {
          result.push({
            id: nodeId,
            name: node.name || node.label || node.type,
            type: node.type,
            templateData: node.templateData,
            label: node.label,
            level: level,
            form: formType,
            page: pageLabel,
            parentId: parentId,
            disabled: true
          });
          if (childNodes && childNodes.length) {
            // En validate_ el parent lo resuelve findFieldPath; en form sí hace falta parentId.
            result = result.concat(
              _this.flattenPageFields(childNodes, level + 1, formType, pageLabel, {
                idPrefix,
                isValidate,
                parentId: isValidate ? undefined : nodeId
              })
            );
          }
        } else if (node.name || node.label) {
          result.push({
            id: nodeId,
            name: node.name || node.label,
            type: node.type,
            templateData: node.templateData,
            label: node.label,
            level: level,
            form: formType,
            page: pageLabel,
            parentId: parentId,
            disabled: false
          });
        }
      });
      return result;
    };

    this.isFilterElementDisabled = (element) => {
      return !element || element.disabled || element.type === "group" || element.type === "simplelist";
    };

    this.getInputElements = function () {
        let elements = [];

        if (_this.use === "datasource") {
            elements.push({ id: "locked", name: "Bloqueado", type: "checkbox", form: "Sistema", page: "Metadatos", level: 0 });
            elements.push({ id: "_startedAt", name: "Creado", type: "timestamp", form: "Sistema", page: "Metadatos", level: 0 });
            elements.push({ id: "closedAt", name: "Cerrado", type: "timestamp", form: "Sistema", page: "Metadatos", level: 0 });
            elements.push({ id: "_createdAt", name: "Subido", type: "timestamp", form: "Sistema", page: "Metadatos", level: 0 });
            elements.push({ id: "memberId", name: "Usuario", type: "text", form: "Sistema", page: "Metadatos", level: 0 });

            let formElements = [];
            if (_this.form && _this.form.pages) {
                formElements = (_this.form.pages || []).reduce((list, page, pageIndex) => {
                    return list.concat(
                        _this.flattenPageFields(page.fields, 0, "Formulario", "Página " + (pageIndex + 1), {})
                    );
                }, []);
            }

            let validateBaseElements = [];
            if (_this.form?.validate_required) {
                validateBaseElements.push({ id: "validateState", name: "Estado", type: "text", form: "Validador", page: "Base", level: 0 });
                validateBaseElements.push({ id: "validateDate", name: "Fecha", type: "timestamp", form: "Validador", page: "Base", level: 0 });
                validateBaseElements.push({ id: "validateUser", name: "Usuario", type: "text", form: "Validador", page: "Base", level: 0 });
                validateBaseElements.push({ id: "validate_lastUser", name: "Último Usuario", type: "text", form: "Validador", page: "Base", level: 0 });
            }

            let validateElements = [];
            if (_this.form && _this.form.validate_pages) {
                validateElements = (_this.form.validate_pages || []).reduce((list, page, pageIndex) => {
                    return list.concat(
                        _this.flattenPageFields(page.fields, 0, "Validador", "Página " + (pageIndex + 1), {
                            idPrefix: "validate_",
                            isValidate: true
                        })
                    );
                }, []);
            }
            elements = elements.concat(formElements, validateBaseElements, validateElements);
        } else {
            elements = BuilderDataService.getElements2(_this.form, undefined, _this.element.id);
        }

        return elements.filter(function (element) {
            if (element.id === _this.element.id) return false;

            switch (element.type) {
                case "text":
                case "select":
                case "formula":
                case "number":
                case "checkbox":
                case "multiple":
                case "date":
                case "timestamp":
                case "qr":
                case "group":
                case "simplelist":
                    return true;
                case "autonumeric":
                    return _this.use === "datasource";
                default:
                    return false;
            }
        });
    };

    this.getIntegrationElements = function () {
        let integrationElements = [];
        if (_this.integration.configuration?.connection?.dynamicParams) {
            for (let key in _this.integration.configuration.connection.dynamicParams) {               
                integrationElements.push({
                    id: key,
                    name: key,
                    type: 'text'
                });
            }
        }
        return integrationElements;
    }

    this.getActionElements = function () {
        let elements = [
            {
                id: "createdAt",
                name: $translate.instant('DASHBOARD.DASH_BUILDER.DATASOURCE.ACTION_FILTER_CREATED_AT'),
                type: "timestamp",
                form: $translate.instant('DASHBOARD.DASH_BUILDER.DATASOURCE.ACTION_FILTER_SYSTEM'),
                page: $translate.instant('DASHBOARD.DASH_BUILDER.DATASOURCE.ACTION_FILTER_METADATA'),
                level: 0
            }
        ];
        (_this.actionFields || []).forEach(function (field) {
            if (!field || !(field.id || field.key)) return;
            elements.push({
                id: field.id || field.key,
                name: field.name || field.label || field.id || field.key,
                type: field.type || "text",
                form: $translate.instant('DASHBOARD.DASH_BUILDER.DATASOURCE.ACTION_DESCRIPTION'),
                page: $translate.instant('DASHBOARD.DASH_BUILDER.DATASOURCE.ACTION_FILTER_RESPONSE'),
                level: 0
            });
        });
        return elements;
    }


    this.getDynamicElements = function () {
      let elements = [];
      elements = BuilderDataService.getElements(null, _this.element);
      return elements.filter(function (element) {
        if (element.id === _this.element.id) {
          return false;
        }

        switch (element.type) {
          case "text":
          case "select":
          case "date":
          case "formula":
          case "number":
          case "checkbox":
          case "multiple":
          case "qr":
            return true;
          case "autonumeric":
            if (_this.use == 'datasource') return true;
            return false;
          default:
            return false;
        }
      });
    }

    function walkConditions(condition) {
      if (condition.type === "field") return true;

      if (condition.type === "operator") {
        if (condition.rules.length < 2) return false;

        return condition.rules.reduce(function (acc, subRule) {
          if (!acc) return false;

          return walkConditions(subRule);
        }, true);
      }
    }

    this.validateConditions = function (conditions) {
      var valid = conditions.reduce(function (prev, rule) {
        if (!prev) return false;

        return walkConditions(rule);
      }, true);

      _this.rulesForm.$setValidity("structure", valid);
      return valid;
    };

    this.treeOptions = {
      dropped: function (sourceNodeScope, destNodesScope, destIndex) {
        _this.valid = _this.validateConditions(_this.condition.conditions);
      }
    };
    if (_this.actionFields) {
        _this.lstElements = _this.getActionElements();
    } else if (!_this.integration) {
        _this.lstElements = _this.getInputElements();
    } else {
        _this.lstElements = _this.getIntegrationElements();
    } 

    // console.log(_this.lstElements);
    $scope.$watch(
      function () {
        return _this.rulesForm.$valid;
      },
      function (n, o) {
        _this.condition.valid = _this.rulesForm.$valid;
      }
    );
  }
];

module.exports = function () {
  return {
    restrict: "E",
    scope: {
      condition: "=",
      element: "=",
      index: "=",
      form: "=",
      integration: "=",
      actionFields: "=",
      use: "@",
      legend: "@",
      help: "@"
    },
    replace: true,
    controller: conditionDirectiveController,
    controllerAs: "ctrl",
    bindToController: true,
    templateUrl:
      "dashboard-builder/conditions-graph/requiredGraphDirective.html"
  };
};
